module.exports = __webpack_public_path__ + "static/media/network-start.ac8b8172.svg";